<template>
  <div class="germplasmAnimal">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 germplasmAnimal-item">
        <div class="searchStyle">
        <el-form :inline="true" :model="searchForm" label-position="top">
          <el-form-item label="资源类型" prop="resourceType">
            <el-select multiple v-model="searchForm.resourceTypeList" clearable placeholder="请选择">
              <el-option v-for="item in resourceTypeListOp" :key="item.id" :label="item.label" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集年份" prop="collectYear">
            <el-date-picker @change="changePick" v-model="searchForm.collectYear" type="year" placeholder="选择年"/>
          </el-form-item>
          <el-form-item label="省" prop="province">
            <el-select v-model="searchForm.province" placeholder="请选择省份">
              <el-option v-for="item in provinceListOp" :key="item.id" :label="item.itemValue" :value="item.itemValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区" prop="area">
            <el-select v-model="searchForm.area" placeholder="请选择地区">
              <el-option v-for="item in areaListOp" :key="item.id" :label="item.itemValue" :value="item.itemValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专题负责人" prop="specialLeader">
            <el-select v-model="searchForm.specialLeader" clearable placeholder="请选择专题负责人">
              <el-option v-for="item in specialLeaderListOp" :key="item.id" :label="item.label" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物种查询" prop="speciesQuery">
            <el-input v-model="searchForm.speciesQuery" placeholder="种中文名或种拉丁名"></el-input>
          </el-form-item>
          <el-form-item label="采集号" prop="collectNumber">
            <el-input clearable v-model="searchForm.collectNumber" placeholder="采集号"></el-input>
          </el-form-item>

          <div style="display: inline-block" class="button">
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="primary" @click="backSubmit">返回</el-button>
          </div>
        </el-form>
        </div>
        <template >
          <el-table  border
              :data="tableData"
              style="width: 100%" :header-cell-style="{backgroundColor: '#eee',color: '#333'}"  :row-style="{height: '8px'}"
                     :cell-style="{padding:'0px'}">
            <el-table-column fixed type="index" header-align="center" align="left" label="ID" width="80">
              <template slot-scope="scope">
                <span>{{ (page - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>

<!--            <el-table-column prop="belongChinese" header-align="center" align="center" label="属中文名" show-overflow-tooltip/>-->
<!--            <el-table-column prop="belongLatin" header-align="center" align="center" label="属拉丁名" show-overflow-tooltip/>-->
            <el-table-column prop="growChinese" header-align="center" align="left" label="种中文名" show-overflow-tooltip/>
            <el-table-column prop="growLatin" header-align="center" align="left" label="种拉丁名" show-overflow-tooltip/>
            <el-table-column prop="sectionChinese" header-align="center" align="left" label="科中文名" show-overflow-tooltip/>-->
            <el-table-column prop="sectionLatin" header-align="center" align="left" label="科拉丁名" show-overflow-tooltip/>
<!--            <el-table-column prop="varietalPopulation" header-align="center" align="center" label="品种/种群" show-overflow-tooltip/>-->
            <el-table-column prop="resourceType" header-align="center" align="left" label="资源类型" show-overflow-tooltip/>
            <el-table-column prop="collectNumber" header-align="center" align="left" label="采集号" show-overflow-tooltip/>
            <el-table-column prop="libNum" header-align="center" align="left" label="库号" show-overflow-tooltip/>
            <el-table-column prop="collectUser" header-align="center" align="left" label="采集人" show-overflow-tooltip/>
<!--            <el-table-column prop="collectTime" header-align="center" align="center" label="采集日期" width="100" show-overflow-tooltip/>-->
            <el-table-column prop="collectYear" header-align="center" align="left" label="采集年份" show-overflow-tooltip/>
            <el-table-column prop="province" header-align="center" align="left" label="省" show-overflow-tooltip/>
            <el-table-column prop="area" header-align="center" align="left" label="地区" show-overflow-tooltip/>
            <el-table-column prop="sampleUnit" header-align="center" align="left" label="单位" show-overflow-tooltip/>
            <el-table-column prop="specialLeader" header-align="center" align="left" label="专题负责人" width="120" show-overflow-tooltip/>
            <el-table-column label="操作" header-align="center"  align="left" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="toTableDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagin"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="page"
                         :page-size="pageSize"
                         :page-sizes="[25,50,75,100]"
                         layout="total,sizes, prev, pager, next"
                         :total="totalPage">
          </el-pagination>
        </template>
<!--        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>-->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import { fetchList } from '@/network/germplasmAnimal/animalgermplasm'
import {getAnimalgermplasm} from "@/network/resourceBaseCommon";
import {getAnimalGermplasmNewResourceType} from "@/network/germplasmAnimal";
export default {
  name: "germplasmAnimal",
  components: { breadcrumb },
  data() {
    return {
    path: '',
    name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      page: 1,
      pageSize: 25,
      totalPage: 0,
      tableData: [],
      type: 'animalGermplasmNew',
      detailType: 'animalgermplasmNew',
      searchForm: {},
      resourceTypeListOp: [],
      provinceListOp: [],
      areaListOp: [],
      specialLeaderListOp: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'
    })
  },
  mounted() {
    this.getList()
  },

  created() {
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '种质资源'
    this.childPath = this.$route.path
    this.getSelectDate()
  },
  methods: {
    changePick(val){
      let a = new Date(val)
      let year = a.getFullYear() + ''
      this.searchForm.collectYear = year
      return  this.searchForm.collectYear
    },
    /**
     * 获取查询数据源
     */
    getSelectDate() {
      getAnimalGermplasmNewResourceType().then(res => {
        this.areaListOp = res.data.data.areaList
        this.provinceListOp = res.data.data.provinceList
        this.resourceTypeListOp = res.data.data.resourceTypeList
        this.specialLeaderListOp = res.data.data.specialLeaderList
      })
    },
    /**
     * 列表查询
     */
    getList() {
      fetchList(Object.assign({
        page: this.page,
        pageSize: this.pageSize,
      }, this.searchForm)).then(response => {
        this.tableData = response.data.data.animalGermplasmNewList
        this.totalPage = response.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    toTableDetail(row) {
      this.$router.push({
        path: '/tableDetail',
        query: {
          id: row.id,
          formName: this.type,
          name: '动物种质'
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getList()
    },
    backSubmit() {
      this.page = 1
      this.searchForm = {}
      this.getList()
    }
  }
}
</script>


<style scoped lang="scss">
@import "../../../assets/css/germplasmAnimal";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>